import { get } from 'lodash';
import React from 'react';

import { Container, Name } from './styled';

export interface IReference {
  id: string;
  visibleName?: string;
}

interface IProps {
  className?: string;
  item: IReference;
}

const Reference: React.FC<IProps> = ({ className, item }) => (
  <Container className={`${className || ''} reference-item`}>
    <Name>{get(item, 'visibleName', 'Unnamed')}</Name>
  </Container>
);

export default Reference;
